// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"789":"200d89a2eb27f60b","5352":"12f5c851506fba82"}[chunkId] + ".css";
};